import React, { Component } from "react";

import { withStyles, MuiThemeProvider } from "@material-ui/core/styles";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";

import foodbookTheme from "../../hoc/Theme";

const styles = theme => ({
  root: {
    position: "fixed",
    height: "100%",
    width: "100%",
    top: "0px",
    left: "0px",
    zIndex: 1200,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  Loader: {
    position: "fixed",
    top: "50%",
    left: "50%"
  }
});

class ProgressCircular extends Component {
  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <Backdrop open={true} />
        <MuiThemeProvider theme={foodbookTheme}>
          <CircularProgress />
        </MuiThemeProvider>
      </div>
    );
  }
}

export default withStyles(styles)(ProgressCircular);



// WEBPACK FOOTER //
// ./src/components/Utils/CircularProgress.js